import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/utilization";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

export const FilterByStaff = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.filters.staff_values);
  const selectedFilters = useSelector((state) => state.utilization.selectedStaffFilters);
  const staffFiltersLoading = useSelector((state) => state.utilization.staffFiltersLoading);

  return (
    <div className="select-box" style={{ width: "200px" }}>
      <p className="offers-title">Staff</p>
      {!staffFiltersLoading ? (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          placeholder="Select Staff"
          enableOnly
          numberDisplayed={0}
          includeSelectAll
          onSelectChange={(data) => dispatch(actionCreators.updateDataByStaff(data))}
        />
      ) : (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      )}
    </div>
  );
};
